export default "<div ui-view></div>\n<st-news class=\"m-t\" rest-resource=\"$ctrl.teamInfo\" mode=\"$ctrl.mode\" news-service=\"$ctrl.teamService\"></st-news>";